import { render, staticRenderFns } from "./Unallocated.vue?vue&type=template&id=13cbbc45&scoped=true&"
import script from "./Unallocated.vue?vue&type=script&lang=js&"
export * from "./Unallocated.vue?vue&type=script&lang=js&"
import style0 from "./Unallocated.vue?vue&type=style&index=0&id=13cbbc45&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cbbc45",
  null
  
)

export default component.exports